export default {
    index:{
        'Brand Pavilion':'品牌馆',
        "Merchant settlement":"商家入驻",
        "APP download":'APP下载',
        "WeChat Mall":'微商城',
        "Locating":'正在定位',
        "Sign in":'登录',
        "sign out":'退出',
        "register":'注册',
        "My Order":'我的订单',
        "my collection":'我的收藏',
        "customer service":'客户服务',
        "help center":'帮助中心',
        "site navigation":'站点导航',
        "User Center":"用户中心",
        "Home page":'网站首页',
        "payment center":'支付中心',
        "There is no product in the shopping cart, buy it now!":'购物车还没有商品,赶紧选购吧!',
        "Go to the shopping cart to checkout":"去购物车结算",
        "shopping cart":'购物车',
        "All Categories":'全部商品分类',
        "No related classification data":'暂无相关分类数据',
        "wholesale market":'批发市场',
        "Merchant shop":'商家店铺',
        "the whole country":'全国',
        "Shopping cart query failed, please try again later!":'购物车查询失败，请稍后再试！',
        "Loading failed, please try again later!":"加载失败，请稍后再试！",
        "Latest Announcement":'最新公告',
        "More":'更多',
        "go and see":'去看看',
        "Template 1105_Title":'模板1105_标题',
        "Template 1111_Title":'模板1111_标题',
        "advertise":'广告',
        "Template 1110_Title":"模板1110_标题",
        "Template 1110_right mark 1":'模板1110_右标1',
        "Template 1110_right mark 2":'模板1110_右标2',
        "Please enter a department name":'请输入部门名称',
        "Please enter the department code":'请输入部门代码',
        "Carousel failed to load, please try again later!":"轮播图加载失败，请稍后再试！",
        "Failed to get address, please try again later":'获取地址失败，请稍后再试',
        "Query failed, please try again later!":'查询失败,请稍后再试!',
        "Failed to get list of articles, please try again later!":"获取文章列表失败，请稍后再试！"
    },
    login:{
        "account":'账号',
        "password":'密码',
        "retrieve password":'找回密码',
        "Sign up now":'立即注册',
        "please enter account":'请输入账号',
        "please enter password":'请输入密码',
        "Query failed, please try again later!":'查询失败,请稍后再试!',
        "login successful":'登录成功',
        "Login failed, please try again later!":'登录失败，请稍后再试！',
        "Phone number":"手机号",
        "verification code":'验证码',
        "Enter SMS verification code":'输入SMS验证码',
        "Seconds to reacquire":"秒后重新获取",
        "Click to sign up to agree":"点击注册表示同意",
        "User Agreement":"用户协议",
        "Trouble logging in":"登录遇到问题",
        "obtain SMS verification code":"获取短信验证码",
        "I have registered, log in now":"我已注册,现在登录",
        "please enter verification code":"请输入验证码",
        "Verification code verification":"验证码校验",
        "Enter SMS verification code":"输入短信验证码",
        "Can not be empty":'不能为空',
        "The password length is 6~16 characters, including at least two types of numbers, letters and symbols":'密码长度6~16位，其中数字，字母和符号至少包含两种',
        "The two passwords do not match":"两次密码不一致",
        "Click to refresh the verification code":'点击验证码刷新',
        "Please enter phone number":"请输入手机号",
        "Sent successfully":"发送成功",
        "Failed to send SMS verification code, please try again later!":"发送短信验证码失败，请稍后再试！",
        "registration success":"注册成功",
        "registration failed, please try again later!":'注册失败，请稍后再试！',
        "Failed to fetch list, please try again later!":"获取列表失败，请稍后再试！"
    },
    car:{
        "user":'用户',
        "grade":'等级',
        "shopping cart":'购物车',
        "i have seen":"我看过的",
        "my favorites":'我收藏的',
        "back to the top":'回到顶部',
        "Items":'件商品',
        "total":'总计',
        "Go to the shopping cart to checkout":'去购物车结算',
        "Yuan":'元',
        "There is nothing in your shopping cart":"您的购物车里什么都没有哦",
        "go see it again":'再去看看吧',
        "my footprint":"我的足迹",
        "No history of your browsing":"暂无您的浏览记录",
        "please sign in!":'请登录！',
        "My track lookup failed, please try again later!":"我的足迹查询失败，请稍后再试！",
    },
    goods:{
        "all":'所有',
        "Classification":"分类",
        "brand":'品牌',
        "sell like hot cakes":"热销",
        "price":'价格',
        "newest":'上新',
        "Negotiable":'面议',
        "add to Shopping Cart":'加入购物车',
        "check the details":'查看详情',
        "Sorry, there are no products under the corresponding product category or filter combination!":'对不起，对应商品分类或筛选组合下没有商品!',
        "Has been successfully added to the shopping cart!":'已成功加入购物车！',
        "continue shopping":'继续购物',
        "Go to the shopping cart to checkout":"去购物车结算",
        "login required":"需要登录",
        "Sure":"确定",
        "Index":'首页',
        "hot sale item":"热卖商品",
        "Failed to query product category, please try again later!":"查询商品分类失败，请稍后再试！",
        "Failed to query the product list, please try again later!":"查询商品列表失败，请稍后再试！",
        "Shopping cart query failed, please try again later!":"购物车查询失败，请稍后再试！",
        "Failed to add cart, please try again later!":"添加购物车失败，请稍后再试！",
        "Temporarily out of stock":"暂时缺货"
    }
   
}


// WEBPACK FOOTER //
// ./src/lang/zh.js